module.exports = __webpack_public_path__ + "img/argentina.4593a46c.webp";